/* LumiBarra — interacciones y animaciones (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var scrollers = [];

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function $(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Titulares que entran palabra a palabra ---------- */
  function splitWords(el) {
    if (!once(el, 'lbSplit')) return;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'lb-w';
            var inner = document.createElement('span');
            inner.style.setProperty('--i', i++);
            inner.textContent = p;
            w.appendChild(inner);
            frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    })(el);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('lb-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }) : null;

  function initReveal(root) {
    $('.lb-split', root).forEach(splitWords);
    $('.lb-reveal, .lb-split', root).forEach(function (el) {
      if (!once(el, 'lbRev')) return;
      if (!io || reduce) { el.classList.add('lb-visible'); return; }
      io.observe(el);
    });
  }

  /* ---------- Cifras que cuentan ---------- */
  function initCount(root) {
    $('[data-lb-count]', root).forEach(function (el) {
      if (!once(el, 'lbCount')) return;
      var target = parseFloat(el.getAttribute('data-lb-count'));
      var suffix = el.getAttribute('data-lb-suffix') || '';
      if (isNaN(target) || reduce || !io) return;
      el.textContent = '0' + suffix;
      var obs = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        obs.disconnect();
        var t0 = performance.now(), dur = 1600;
        (function tick(t) {
          var p = clamp((t - t0) / dur, 0, 1);
          var eased = 1 - Math.pow(1 - p, 4);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      }, { threshold: 0.6 });
      obs.observe(el);
    });
  }

  /* ---------- Hero: la luz se enciende + linterna al cursor ---------- */
  function initHero(root) {
    $('.lb-hero', root).forEach(function (hero) {
      if (!once(hero, 'lbHero')) return;
      var delay = parseInt(hero.getAttribute('data-delay') || '350', 10);
      if (reduce || document.documentElement.classList.contains('shopify-design-mode')) hero.classList.add('is-on');
      else setTimeout(function () { hero.classList.add('is-on'); }, delay);
      if (finePointer && hero.hasAttribute('data-torch')) {
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect();
          hero.style.setProperty('--mx', (e.clientX - r.left) + 'px');
          hero.style.setProperty('--my', (e.clientY - r.top) + 'px');
        });
      }
    });
  }

  /* ---------- Efectos ligados al scroll (parallax, zoom, escala) ---------- */
  function initScrollFx(root) {
    $('[data-lb-parallax]', root).forEach(function (el) {
      if (!once(el, 'lbPar')) return;
      var k = parseFloat(el.getAttribute('data-lb-parallax')) || 0.15;
      var box = el.closest('.lb-hero, .lb-regalo__card') || el.parentElement;
      scrollers.push(function (vh) {
        var r = box.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        el.style.setProperty('--lb-par', (-(r.top) * k).toFixed(1) + 'px');
      });
    });
    $('[data-lb-scale]', root).forEach(function (el) {
      if (!once(el, 'lbSc')) return;
      var from = parseFloat(el.getAttribute('data-lb-scale')) || 0.94;
      scrollers.push(function (vh) {
        var r = el.getBoundingClientRect();
        var p = clamp((vh - r.top) / (vh * 0.85), 0, 1);
        el.style.setProperty('--lb-sc', (from + (1 - from) * p).toFixed(4));
      });
    });
    $('[data-lb-zoom]', root).forEach(function (el) {
      if (!once(el, 'lbZoom')) return;
      var box = el.closest('.lb-cta') || el;
      scrollers.push(function (vh) {
        var r = box.getBoundingClientRect();
        var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
        el.style.setProperty('--lb-zoom', (1.14 - 0.14 * p).toFixed(4));
      });
    });
    $('.lb-pasos', root).forEach(function (sec) {
      var list = sec.querySelector('.lb-pasos__list');
      if (!list || !once(sec, 'lbLine')) return;
      scrollers.push(function (vh) {
        var r = list.getBoundingClientRect();
        var p = clamp((vh * 0.5 - r.top) / r.height, 0, 1);
        sec.style.setProperty('--lb-line', p.toFixed(4));
      });
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      scrollers.forEach(function (fn) { fn(vh); });
      ticking = false;
    });
  }

  /* ---------- Tarjetas que se inclinan al cursor ---------- */
  function initTilt(root) {
    if (!finePointer || reduce) return;
    $('[data-lb-tilt]', root).forEach(function (card) {
      if (!once(card, 'lbTilt')) return;
      var max = parseFloat(card.getAttribute('data-lb-tilt')) || 6;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--ry', ((x - 0.5) * max).toFixed(2) + 'deg');
        card.style.setProperty('--rx', ((0.5 - y) * max).toFixed(2) + 'deg');
        card.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Pasos: la escena cambia según el paso visible ---------- */
  function initPasos(root) {
    $('.lb-pasos', root).forEach(function (sec) {
      if (!once(sec, 'lbPasos')) return;
      var steps = $('.lb-paso', sec);
      var imgs = $('.lb-pasos__frame img', sec);
      var num = sec.querySelector('[data-lb-paso-num]');
      var badge = sec.querySelector('.lb-pasos__badge');
      function activate(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
        if (num) num.textContent = String(i + 1).padStart(2, '0');
        if (badge) badge.style.setProperty('--lb-prog', ((i + 1) / steps.length).toFixed(3));
      }
      activate(0);
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) activate(steps.indexOf(e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { obs.observe(s); });
    });
  }

  /* ---------- Selector de tono de luz ---------- */
  function initTonos(root) {
    $('.lb-tonos', root).forEach(function (sec) {
      if (!once(sec, 'lbTonos')) return;
      var btns = $('.lb-tono', sec);
      var imgs = $('.lb-tonos__media img', sec);
      var media = sec.querySelector('.lb-tonos__media');
      var timer = null;
      var auto = parseInt(sec.getAttribute('data-auto') || '0', 10);
      function set(i, user) {
        btns.forEach(function (b, j) { b.classList.toggle('is-active', j === i); b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
        var b = btns[i];
        sec.style.setProperty('--lb-tono', b.getAttribute('data-color'));
        sec.style.setProperty('--lb-k', b.getAttribute('data-pos') + '%');
        if (media && !reduce) { media.classList.remove('is-flick'); void media.offsetWidth; media.classList.add('is-flick'); }
        if (user && timer) { clearInterval(timer); timer = null; }
      }
      btns.forEach(function (b, i) { b.addEventListener('click', function () { set(i, true); }); });
      var start = parseInt(sec.getAttribute('data-start') || '0', 10);
      set(clamp(start, 0, btns.length - 1), false);
      if (media) media.classList.remove('is-flick');
      if (auto > 0 && !reduce && 'IntersectionObserver' in window) {
        var cur = start;
        var obs = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting && !timer && !sec.dataset.lbTouched) {
            timer = setInterval(function () { cur = (cur + 1) % btns.length; set(cur, false); }, auto * 1000);
          } else if (!en[0].isIntersecting && timer) { clearInterval(timer); timer = null; }
        }, { threshold: 0.4 });
        obs.observe(sec);
        btns.forEach(function (b) { b.addEventListener('click', function () { sec.dataset.lbTouched = '1'; }); });
      }
    });
  }

  /* ---------- Preguntas desplegables ---------- */
  function initFaq(root) {
    $('.lb-faq__q', root).forEach(function (q) {
      if (!once(q, 'lbFaq')) return;
      q.addEventListener('click', function () {
        var item = q.closest('.lb-faq__item');
        var open = !item.classList.contains('is-open');
        var group = item.parentElement;
        if (group && group.hasAttribute('data-lb-single')) {
          $('.lb-faq__item.is-open', group).forEach(function (o) {
            if (o !== item) { o.classList.remove('is-open'); o.querySelector('.lb-faq__q').setAttribute('aria-expanded', 'false'); }
          });
        }
        item.classList.toggle('is-open', open);
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    $('.lb-gal', root).forEach(function (gal) {
      if (!once(gal, 'lbGal')) return;
      var track = gal.querySelector('.lb-gal__track');
      var slides = $('.lb-gal__slide', gal);
      var thumbs = $('.lb-gal__thumb', gal);
      var count = gal.querySelector('[data-lb-gal-count]');
      if (!track || !slides.length) return;
      var cur = 0;
      function go(i) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }
      function mark(i) {
        cur = i;
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = gal.querySelector('.lb-gal__nav--prev'), next = gal.querySelector('.lb-gal__nav--next');
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); });
      }, { passive: true });
      mark(0);
    });
  }

  /* ---------- Cantidad ---------- */
  function initQty(root) {
    $('.lb-qty', root).forEach(function (q) {
      if (!once(q, 'lbQty')) return;
      var input = q.querySelector('input');
      $('button', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-step'), 10);
          input.value = clamp(v, 1, 99);
        });
      });
    });
  }

  /* ---------- Variantes ---------- */
  function initVariants(root) {
    $('[data-lb-product]', root).forEach(function (wrap) {
      if (!once(wrap, 'lbVar')) return;
      var dataEl = wrap.querySelector('[data-lb-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var form = wrap.querySelector('[data-lb-cart-form]');
      var idInput = form && form.querySelector('input[name="id"]');
      var priceEl = wrap.querySelector('[data-lb-price]');
      var compareEl = wrap.querySelector('[data-lb-compare]');
      var btns = $('[data-lb-add]', wrap.closest('.shopify-section') || wrap).concat($('.lb-sticky [data-lb-add]'));
      var stickyPrice = document.querySelector('[data-lb-sticky-price]');
      var money = wrap.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €';
      function fmt(cents) {
        var n = (cents / 100).toFixed(2);
        var withComma = n.replace('.', ',');
        return money.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma).replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
      }
      function update() {
        var opts = $('.lb-opt', wrap).map(function (g) {
          var c = g.querySelector('input:checked');
          return c ? c.value : null;
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        btns.forEach(function (b) {
          var lab = b.querySelector('.lb-btn__label');
          if (!v || !v.available) { b.disabled = true; if (lab) lab.textContent = b.getAttribute('data-soldout'); }
          else { b.disabled = false; if (lab) lab.textContent = b.getAttribute('data-label'); }
        });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (stickyPrice) stickyPrice.textContent = fmt(v.price);
        wrap.dispatchEvent(new CustomEvent('lb:variant', { detail: { price: v.price } }));
        if (compareEl) {
          compareEl.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : '';
          compareEl.hidden = !(v.compare_at_price > v.price);
        }
        if (window.history && window.history.replaceState && wrap.hasAttribute('data-update-url')) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      $('.lb-opt input', wrap).forEach(function (i) { i.addEventListener('change', update); });
    });
  }

  /* ---------- Selector de packs (descuento por cantidad) ---------- */
  function fmtMoney(cents, format) {
    var n = (cents / 100).toFixed(2);
    return (format || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, n);
  }
  function initPacks(root) {
    $('[data-lb-packs]', root).forEach(function (group) {
      if (!once(group, 'lbPacks')) return;
      var wrap = group.closest('[data-lb-product]');
      var form = group.closest('form');
      var qty = form && form.querySelector('[data-pk-qty]');
      var sum = form && form.querySelector('[data-pk-sum]');
      var format = wrap && wrap.getAttribute('data-money-format');
      var saveWord = group.getAttribute('data-save') || 'Ahorras';
      var price = parseInt(group.getAttribute('data-price'), 10);
      var radios = $('input[type="radio"]', group);
      function render() {
        var sel = null;
        radios.forEach(function (r) {
          var q = parseInt(r.value, 10), d = parseInt(r.getAttribute('data-desc'), 10) || 0;
          var unit = price - d, total = unit * q, orig = price * q;
          var lab = r.closest('.lb-pk');
          var u = lab.querySelector('[data-pk-unit]'), t = lab.querySelector('[data-pk-total]'), o = lab.querySelector('[data-pk-orig]');
          if (u) u.textContent = fmtMoney(unit, format);
          if (t) t.textContent = fmtMoney(total, format);
          if (o) o.textContent = fmtMoney(orig, format);
          var nm = lab.querySelector('.lb-pk__info b');
          if (r.checked) sel = { q: q, total: total, save: orig - total, name: nm ? nm.textContent : '' };
        });
        if (!sel) return;
        if (qty) qty.value = sel.q;
        if (sum) {
          sum.textContent = '';
          var parts = [['span', 'Total'], ['b', fmtMoney(sel.total, format)]];
          if (sel.save > 0) parts.push(['em', saveWord + ' ' + fmtMoney(sel.save, format)]);
          parts.forEach(function (p) { var el = document.createElement(p[0]); el.textContent = p[1]; sum.appendChild(el); });
        }
        if (stickyPrice) stickyPrice.textContent = fmtMoney(sel.total, format);
        if (stickyName && sel.name) stickyName.textContent = sel.name;
      }
      var stickyPrice = document.querySelector('[data-lb-sticky-price]');
      var stickyName = document.querySelector('[data-lb-sticky-name]');
      var want = new URLSearchParams(window.location.search).get('pack');
      if (want) radios.forEach(function (r) { if (r.value === want) r.checked = true; });
      radios.forEach(function (r) { r.addEventListener('change', render); });
      if (wrap) wrap.addEventListener('lb:variant', function (e) { price = e.detail.price; render(); });
      render();
    });
  }

  /* ---------- Aviso de envío con fechas estimadas (días laborables) ---------- */
  function initShip(root) {
    $('[data-lb-ship]', root).forEach(function (box) {
      if (!once(box, 'lbShip') || box.getAttribute('data-fechas') !== 'true') return;
      var target = box.querySelector('[data-lb-ship-text]');
      var tpl = box.getAttribute('data-plantilla') || 'Recíbelo entre el [desde] y el [hasta]';
      function addWorkdays(n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
        return d;
      }
      var a = addWorkdays(parseInt(box.getAttribute('data-min'), 10) || 8);
      var b = addWorkdays(parseInt(box.getAttribute('data-max'), 10) || 12);
      var opt = { day: 'numeric', month: 'short' };
      var fa = a.toLocaleDateString('es-ES', opt), fb = b.toLocaleDateString('es-ES', opt);
      if (a.getMonth() === b.getMonth()) fa = String(a.getDate());
      var esc = function (s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      if (target) target.innerHTML = esc(tpl).replace('[desde]', '<strong>' + esc(fa) + '</strong>').replace('[hasta]', '<strong>' + esc(fb) + '</strong>');
    });
  }

  /* ---------- Añadir al carrito (abre el carrito lateral del tema) ---------- */
  function initCart(root) {
    $('[data-lb-cart-form]', root).forEach(function (form) {
      if (!once(form, 'lbCart')) return;
      var consent = form.querySelector('[data-lb-consent]');
      if (consent) consent.addEventListener('change', function () {
        consent.closest('.lb-consent').classList.remove('is-error');
        var m = form.parentElement.querySelector('.lb-buy__msg');
        if (m && consent.checked) m.textContent = '';
      });
      form.addEventListener('submit', function (e) {
        // Producto digital: sin la casilla marcada no se añade al carrito.
        if (consent && !consent.checked) {
          e.preventDefault();
          var box = consent.closest('.lb-consent'), m = form.parentElement.querySelector('.lb-buy__msg');
          box.classList.remove('is-error'); void box.offsetWidth; box.classList.add('is-error');
          if (m) m.textContent = consent.getAttribute('data-msg') || '';
          box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          consent.focus({ preventScroll: true });
          return;
        }
        var drawer = document.querySelector('cart-drawer');
        if (!window.fetch || !drawer || typeof drawer.renderContents !== 'function') return; // envío normal al carrito
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var msg = form.parentElement.querySelector('.lb-buy__msg') || document.querySelector('.lb-buy__msg');
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
        if (msg) msg.textContent = '';
        var fd = new FormData(form);
        var ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
        fd.append('sections', ids);
        fd.append('sections_url', window.location.pathname);
        drawer.setActiveElement && drawer.setActiveElement(document.activeElement);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { if (msg) msg.textContent = res.description || res.message || 'No se ha podido añadir.'; return; }
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        }).catch(function () { form.submit(); }).finally(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        });
      });
    });
  }

  /* ---------- Barra de compra fija en móvil ---------- */
  function initSticky(root) {
    $('.lb-sticky', root).forEach(function (bar) {
      if (!once(bar, 'lbSticky')) return;
      var target = document.querySelector('[data-lb-main-add]');
      var form = document.querySelector('[data-lb-main-form]');
      if (!target || !form || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (en) {
        var e = en[0];
        bar.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(target);
      var b = bar.querySelector('[data-lb-add]');
      if (b) b.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type="submit"]').click();
      });
    });
  }

  function initAll(root) {
    initReveal(root); initCount(root); initHero(root); initScrollFx(root); initTilt(root);
    initPasos(root); initTonos(root); initFaq(root); initGallery(root); initQty(root);
    initVariants(root); initPacks(root); initShip(root); initCart(root); initSticky(root);
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
